import * as React from 'react';

import { Progress } from 'components/ui/progress';
import { cn } from 'lib/utils';

/**
 * Pieza NUEVA (no es puerto de chirigota) — nace de la pantalla "Pantalla de
 * aterrizaje Multicuenta" (Resumen), wireframe 05 · "Usuario con varios
 * planes": el detalle compacto de un traspaso en curso DENTRO de la card de
 * un plan en Resumen, no la vista de detalle de un plan concreto (esa ya
 * tiene `ui/TransferInfoCard`, con Origen/Destino/Código DGS + importe — más
 * densa de lo que cabe en una card de listado).
 *
 * Pensado como `children` de `ui/TransferStatusCard`: al usarla, no pasar
 * `originName` a `TransferStatusCard` (el nombre del banco va en la línea de
 * esta pieza, no repetido en el título de la cabecera).
 */
export interface TransferProgressSummaryProps {
	/** Vacío si no se sabe de dónde viene el dinero: la línea empieza por el plazo. */
	originName: string;
	/** Ej. "día 6 de 15-30" — en qué punto del plazo de traspaso está hoy. */
	dayRangeLabel: string;
	/** Ej. "llegada estimada 25 sept". */
	etaLabel: string;
	/** 0-100. */
	progressPct: number;
	className?: string;
}

export const TransferProgressSummary = ({
	originName,
	dayRangeLabel,
	etaLabel,
	progressPct,
	className
}: TransferProgressSummaryProps) => (
	<div className={cn('flex flex-col gap-2', className)}>
		<p className="text-sm text-muted-foreground">
			{[originName.trim(), dayRangeLabel, etaLabel].filter(Boolean).join(' · ')}
		</p>
		<Progress
			value={progressPct}
			className="h-1.5"
			aria-label={`Progreso del traspaso: ${progressPct}%`}
		/>
	</div>
);
